import React from 'react';
import { Dropdown } from 'antd';
import DataNode from '../../../../interfaces/dataRoom/dataNode';
import FileMenu from './FileMenu';
import UpdatedDate from './UpdatedDate';

interface FolderProps {
  item: DataNode;
  isMobile: boolean;
  isEditable: boolean;
  onClick: (e: any) => void;
  menu;
}

const Folder: React.FC<FolderProps> = ({
  item,
  isMobile,
  isEditable,
  onClick,
  menu,
}) => {
  return (
    <div className="d-flex justify-content-space-between">
      <span>
        {item.name.length > 30 ? `${item.name.slice(0, 30)}...` : item.name}
      </span>
      {!isMobile && (
        <div
          className="d-flex align-items-center"
          onClick={e => {
            e.stopPropagation();
          }}
        >
          <span className="mr-10">{item.createdBy}</span>
          <span className="data-room__first-node-info-size">
            {item.nodes.length}
          </span>
          <span className="mr-50">
            <UpdatedDate>{item.createdDate}</UpdatedDate>
          </span>
          {isEditable && (
            <Dropdown.Button
              className="context-menu"
              onClick={onClick}
              overlay={menu}
            ></Dropdown.Button>
          )}
        </div>
      )}
    </div>
  );
};

export default Folder;
